import { IAssistantWalkthroughFeatureModel } from "api/services/chat/assistant";

import { getAssistantWalkthroughUrl } from "../../utils";

export function getAssistantWalkthroughFeatureOffers(
  features: IAssistantWalkthroughFeatureModel[],
  pendingIds: string[]
) {
  const pending = new Set(pendingIds);

  return features.map((feature) => ({
    ...feature,
    href: getAssistantWalkthroughUrl(feature.guide, feature.id),
    pending: pending.has(feature.id),
  }));
}
